export { default as rawTimeZones } from "../raw-time-zones.json";
export { default as timeZonesNames } from "../time-zones-names.json";
export { default as getTimeZones } from "./getTimeZones.js";
